import type { components } from '@fluencelabs/vodopad-admin-api'
import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { unwrapApiData } from '@/api/unwrapApiResult'

export type ChargeWindow = components['schemas']['ChargePeriodDto']

const STALE_TIME = 60_000
export const BUSINESS_QUERY_KEY = 'business'

export function useCharges(days: number, window: ChargeWindow) {
  return useQuery({
    queryKey: [BUSINESS_QUERY_KEY, 'charges', days, window],
    queryFn: async () =>
      unwrapApiData(
        await client.GET('/v1/admin/charges', {
          params: { query: { days, window } },
        }),
        'Failed to load charges',
      ),
    staleTime: STALE_TIME,
  })
}

export function useCredited(days: number) {
  return useQuery({
    queryKey: [BUSINESS_QUERY_KEY, 'credited', days],
    queryFn: async () => {
      const metrics = unwrapApiData(
        await client.GET('/v1/admin/metrics', { params: { query: { days } } }),
        'Failed to load credited amounts',
      )
      const points = metrics.creditedAmountCents
      return { points, cents: points.reduce((sum, p) => sum + p.value, 0) }
    },
    staleTime: STALE_TIME,
  })
}

export function useCapacity() {
  return useQuery({
    queryKey: [BUSINESS_QUERY_KEY, 'capacity'],
    queryFn: async () =>
      unwrapApiData(
        await client.GET('/v1/admin/analytics/cpu/capacity'),
        'Failed to load capacity',
      ),
    staleTime: STALE_TIME,
  })
}
